import { Locale } from '@yi/core';
import { i18n_minutes } from '@yi/i18n/phrases/i18n_minutes';

import type { EpisodeDuration } from '~/src/common/lean-back';

export function durationFormatter({
  duration,
  locale,
}: {
  duration: EpisodeDuration | null;
  locale: Locale;
}) {
  if (duration === null) {
    return null;
  }
  return `${duration.minutes} ${i18n_minutes(locale)}`;
}
